import { useCallback, useEffect, useState } from "react";

import { api } from "services/api.service";

type OrganizationDeviceTypeRow = {
  uuid: string;
  name: string;
};

export default function useOrgDeviceTypeOptions() {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    return api
      .get<{ organizationDeviceTypes?: OrganizationDeviceTypeRow[] }>("/organization_device_types")
      .then((res) => {
        const list = res.data.organizationDeviceTypes ?? [];
        setOptions(list.map((r) => r.name).filter(Boolean));
      })
      .catch(() => {
        setOptions([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { options, loading, refresh };
}
